@if (alertInfo.show) {
  <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
    <div [innerHTML]="alertInfo.message"></div>
  </ngb-alert>
}
@if (jurisdictionsOptions.length > 0) {
  <form [formGroup]="form">
    <div class="row g-3">
      <div class="col-sm-6 mt-2">
        <select-field [selectFormControl]="getRegulationJurisdictionsSelect()" [options]="jurisdictionsOptions"
          [readonly]="readonlyRegulationsForm" label="Jurisdictions"/>
      </div>        <div class="col-sm-6 mt-2">
      <select-field [selectFormControl]="getRegulationLawsSelect()" [options]="lawsOptions"
        [readonly]="readonlyRegulationsForm"
        label="Law" />
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6 mt-2">
      <input-field type="text" [inputFormControl]="getRegulationTitleInput()" label="Title" placeholder="Title"
        [readonly]="readonlyRegulationsForm" />
    </div>
    <div class="col-sm-6 mt-2">
      <textarea-field label="Details" placeholder="Write details here..."
        [textareaFormControl]="getRegulationDesrciptionInput()"
        [readonly]="readonlyRegulationsForm"/>
    </div>
  </div>
</form>
}